import { State } from "../types/store";



export const selectChatMessages = (state: State) => state.chat.messages;
export const selectChatOpen = (state: State) => state.chat.isOpen;
export const selectChatLoading = (state: State) => state.chat.loading;
